var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"btn-group btn-group-sm"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.verMovimiento}},[_vm._v("\n    Ver Movimiento\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }